import React, {Component} from 'react';
import './SIgnFlowManage.scss';
import Checkbox from "../../../shared/forms/Checkbox";
import ReactTooltip from 'react-tooltip';
import RolesOptions from './RolesOptions';
import {connect} from "react-redux";
import departmentSettingsActionsCreators from '../../store/department-settings/action-creators/index';

class SignFlowManage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedFormType: ''
    }
  }

  componentWillMount() {
    this.props.loadDepartmentSettings();
  }

  get formTypes() {
    return this.props.formTypes.filter(formType => this.props.signFlow[formType.short])
  }

  roleShortName(role) {
    const roles = this.props.settings.rolesSettings;
    const roleShortName = roles && roles[role + '_short'];

    if (roleShortName) {
      return roleShortName;
    }

    return role;
  }

  onRequireChange(type, action, event) {
    this.props.onChange({
      ...this.props.signFlow,
      [type]: {
        ...this.props.signFlow[type],
        [action]: {
          ...this.props.signFlow[type][action],
          required: event.target.checked
        }
      }
    })
  }

  onRolesAdd(type, action, role) {
    this.props.onChange({
      ...this.props.signFlow,
      [type]: {
        ...(this.props.signFlow[type] || {}),
        [action]: {
          ...(this.props.signFlow[type] ? this.props.signFlow[type][action] : {}),
          roles: [...(this.getRoles(this.props.signFlow, type, action)).filter(r => r !== role), role]
        }
      }
    })
  }

  onRolesRemove(type, action, role) {
    this.props.onChange({
      ...this.props.signFlow,
      [type]: {
        ...this.props.signFlow[type],
        [action]: {
          ...this.props.signFlow[type][action],
          roles: this.props.signFlow[type][action].roles.filter(r => r !== role)
        }
      }
    })
  }

  getRoles(signFlow, type, action) {
    return signFlow[type] && signFlow[type][action]
      ? signFlow[type][action].roles || []
      : []
  }

 /***
 getProgramFullName(programType) {
    const form = this.props.forms.find(form => form.type === programType && form.status === 'current');

    if (form) {
      return form.name;
    }
  }
  */

  getRequired(signFlow, type, action) {
    return signFlow[type] && signFlow[type][action]
      ? signFlow[type][action].required
      : false
  }

  get notListedFormTypes() {
    return this.props.formTypes.filter(formType => !this.props.signFlow[formType.short])
  }

  addNewFormType(e) {
    this.props.onChange({
      ...this.props.signFlow,
      [e.target.value]: {}
    })
  }

  changeHandler(type, action, role) {
    this.onRolesAdd(type, action, role);
  }

  render() {
    let {signFlow, canEdit} = this.props;

    return (
      <div className="sign-flow-manage">
        {this.formTypes.map((type) => (
          <div key={type.short} className="sign-flow">
            <ReactTooltip
              place="top"
              className="customTheme"
              effect="solid"
            />
            <div className="form-type" data-tip={type.name}>{type.short}</div>

            <div className="form-actor">
              <div className="form-action">Submitted by</div>
              {this.getRoles(signFlow, type.short, 'submit').map(role => (
                <div
                  className="action-role"
                  key={role}
                  onClick={() => canEdit && this.onRolesRemove(type.short, 'submit', role)}>
                  <span>{this.roleShortName(role)}</span>
                  {canEdit && (<i className="fa fa-close"/>)}
                </div>
              ))}
              {canEdit && (
                <div className="form-group">
                  <RolesOptions type={type.short} action="submit" onChange={this.changeHandler.bind(this)} />
                </div>
              )}

            </div>
            <div className="form-actor">
              <div className="form-action">
                <Checkbox
                  checked={this.getRequired(signFlow, type.short, 'acknowledge')}
                  disabled={!canEdit}
                  onChange={(e) => this.onRequireChange(type.short, 'acknowledge', e)} label={'Acknowledge'}/>
              </div>
              {this.getRoles(signFlow, type.short, 'acknowledge').map(role => (
                <div
                  className="action-role"
                  key={role}
                  onClick={() => canEdit && this.onRolesRemove(type.short, 'acknowledge', role)}>
                  <span>{this.roleShortName(role)}</span>
                  {canEdit && (<i className="fa fa-close"/>)}
                </div>
              ))}
              {canEdit && (
                <div className="form-group">
                  <RolesOptions availableRoles={['oit', 'fto']} type={type.short} action="acknowledge"
                                onChange={this.changeHandler.bind(this)}/>
                </div>
              )}
            </div>
            <div className="form-actor">
              <div className="form-action">
                <Checkbox
                  checked={this.getRequired(signFlow, type.short, 'approve_one')}
                  disabled={!canEdit}
                  onChange={(e) => this.onRequireChange(type.short, 'approve_one', e)} label={'Approve one'}/>
              </div>
              {this.getRoles(signFlow, type.short, 'approve_one').map(role => (
                <div
                  className="action-role"
                  key={role}
                  onClick={() => canEdit && this.onRolesRemove(type.short, 'approve_one', role)}>
                  <span>{this.roleShortName(role)}</span>
                  {canEdit && (<i className="fa fa-close"/>)}
                </div>
              ))}
              {canEdit && (
                <div className="form-group">
                  <RolesOptions type={type.short} action="approve_one" onChange={this.changeHandler.bind(this)} />
                </div>
              )}
            </div>
            <div className="form-actor">
              <div className="form-action">
                <Checkbox
                  checked={this.getRequired(signFlow, type.short, 'approve_two')}
                  disabled={!canEdit}
                  onChange={(e) => this.onRequireChange(type.short, 'approve_two', e)} label={'Approve two'}/>
              </div>
              {this.getRoles(signFlow, type.short, 'approve_two').map(role => (
                <div
                  className="action-role"
                  key={role}
                  onClick={() => canEdit && this.onRolesRemove(type.short, 'approve_two', role)}>
                  <span>{this.roleShortName(role)}</span>
                  {canEdit && (<i className="fa fa-close"/>)}
                </div>
              ))}
              {canEdit && (
                <div className="form-group">
                  <RolesOptions type={type.short} action="approve_two" onChange={this.changeHandler.bind(this)} />
                </div>
              )}
            </div>
            <div className="form-actor">
              <div className="form-action">
                <Checkbox
                  checked={this.getRequired(signFlow, type.short, 'approve_three')}
                  disabled={!canEdit}
                  onChange={(e) => this.onRequireChange(type.short, 'approve_three', e)} label={'Approve three'}/>
              </div>
              {this.getRoles(signFlow, type.short, 'approve_three').map(role => (
                <div
                  className="action-role"
                  key={role}
                  onClick={() => canEdit && this.onRolesRemove(type.short, 'approve_three', role)}>
                  <span>{this.roleShortName(role)}</span>
                  {canEdit && (<i className="fa fa-close"/>)}
                </div>
              ))}
              {canEdit && (
                <div className="form-group">
                  <RolesOptions type={type.short} action="approve_three" onChange={this.changeHandler.bind(this)}/>
                </div>
              )}
            </div>
            <div className="form-actor">
              <div className="form-action">
                <Checkbox
                  checked={this.getRequired(signFlow, type.short, 'approve_four')}
                  disabled={!canEdit}
                  onChange={(e) => this.onRequireChange(type.short, 'approve_four', e)} label={'Approve four'}/>
              </div>
              {this.getRoles(signFlow, type.short, 'approve_four').map(role => (
                <div
                  className="action-role"
                  key={role}
                  onClick={() => canEdit && this.onRolesRemove(type.short, 'approve_four', role)}>
                  <span>{this.roleShortName(role)}</span>
                  {canEdit && (<i className="fa fa-close"/>)}
                </div>
              ))}
              {canEdit && (
                <div className="form-group">
                  <RolesOptions type={type.short} action="approve_four" onChange={this.changeHandler.bind(this)}/>
                </div>
              )}
            </div>
            <div className="form-actor">
              <div className="form-action">
                <Checkbox
                  checked={this.getRequired(signFlow, type.short, 'approve_five')}
                  disabled={!canEdit}
                  onChange={(e) => this.onRequireChange(type.short, 'approve_five', e)} label={'Approve five'}/>
              </div>
              {this.getRoles(signFlow, type.short, 'approve_five').map(role => (
                <div
                  className="action-role"
                  key={role}
                  onClick={() => canEdit && this.onRolesRemove(type.short, 'approve_five', role)}>
                  <span>{this.roleShortName(role)}</span>
                  {canEdit && (<i className="fa fa-close"/>)}
                </div>
              ))}
              {canEdit && (
                <div className="form-group">
                  <RolesOptions type={type.short} action="approve_five" onChange={this.changeHandler.bind(this)}/>
                </div>
              )}
            </div>
          </div>
        ))}
        <div className="text-center">
          <div className="form-group" style={{width: '300px', display: 'inline-block'}}>
            <select value={this.state.selectedFormType} className="form-control"
                    onChange={(e) => this.addNewFormType(e)}>
              <option value="">Add new form type</option>
              {this.notListedFormTypes.map(formType => (
                <option value={formType.short}>{formType.short.toUpperCase()} - {formType.name}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    forms: state.forms.list,
    settings: state.departmentSettings.settings
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadDepartmentSettings: () => {
      dispatch(departmentSettingsActionsCreators.loadDepartmentSettings());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignFlowManage);
